module.exports = "/_next/static/images/stripe-1ec00e93c68ac5572200015201951293.png";